<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <!-- 登录弹窗 -->
    <logiodialog />
    <!-- 消息弹窗 -->
    <InFormDetail @noticeReadNotice="noticeReadNotice" ref="InFormDetail" />
  </div>

</template>

<script>
import logiodialog from './components/logiodialog/index.vue'
import InFormDetail from "../src/views/UserCenter/views/inform/InFormDetail.vue";
export default {
  data() {
    return {
      readItem: {},// 未读 消息
    }
  },
  components: {
    logiodialog,
    InFormDetail
  },
  mounted() {
    window.addEventListener('load', () => {
      //写入你想要执行的代码
      if (
        this.$store.state.searchInfo !== '' &&
        this.$route.name !== 'CommoditySearch'
      ) {
        this.$store.state.searchInfo = ''
      }
    })
  },

  watch: {
    $route(to, from) {
      if (
        this.$store.state.searchInfo !== '' &&
        to.path !== '/commoditySearch'
      ) {
        this.$store.state.searchInfo = ''
      }
    },
  },
  created() {

    // 获取汇率和用户信息
    this.commonExchangeRate()
    if (localStorage.getItem('russia_user_token') || sessionStorage.getItem('russia_user_token')) {
      // 如果用户登录了
      // 获取未读消息
      this.noticeUnreadNotice()
      this.$api.EuropegetUserInfo().then((res) => {
        // 登录失效
        if (res.code != 0) {
          this.$store.commit('userData', null)
          localStorage.removeItem('russia_user_token')
          // 有需要验证的用户中心
          let requireAuth = this.$route.matched[0].meta.requireAuth
          if (requireAuth) {
            this.$fun.toPage('/')
          }

        } else {
          return this.$store.commit('userData', res.data) // 用户信息存储
        }
      })
    } else {
      this.$store.commit('userData', null)
      localStorage.removeItem('russia_user_token')
    }

  },
  methods: {
    fanyi() {
      localStorage.removeItem('fanyi')
      this.$forceUpdate()
    },
    async noticeUnreadNotice() {
      const res = await this.$api.noticeUnreadNotice()
      if (res.code !== 0) {
        return
      }
      if (res.data.length > 0) {
        this.readItem = res.data[0]
        // 打开消息就已读
        this.$refs.InFormDetail.open(this.readItem);
      }

    },
    //消息标记
    noticeReadNotice() {
      this.$api.noticeReadNotice({ id: this.readItem.id }).then((res) => {
        this.noticeUnreadNotice()
      })
    },
    commonExchangeRate() {
      // 获取汇率
      this.$api.commonExchangeRate().then((res) => {
        this.$store.commit('getexchangeRate', res.data)
      })
    },
    getfanyi() {
      let list = []
      language.forEach((item) => {
        if (item.key == item.value) {
          list.push(item)
        }
      })
      require.ensure([], () => {
        const { export_json_to_excel } = require('@/utlis/Export2Excel')
        const tHeader = ['中文', '英文翻译']
        const filterVal = ['key']

        const data = this.formatJson(filterVal, list)
        export_json_to_excel(tHeader, data, '俄罗斯站待翻译')
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]))
    },
  },
}
</script>
<style lang="scss">
@import './css/mixin';



.message-login {
  background: #ffffff;

  border-radius: 20px !important;

  .el-message-box__header {
    display: flex;
    justify-content: flex-start;
    font-weight: bold;
    height: 60px;
    align-items: flex-end;
    font-size: 16px;
    color: #121212;
    padding-left: 40px;

    .el-icon-warning {
      display: none;
    }
  }

  .el-icon-warning {
    display: none;
  }

  .el-icon-close {
    font-weight: 700;
    font-size: 20px;
    margin-right: 5px;
    color: #121212;

    &:hover {
      color: #121212 !important;
    }
  }

  .el-message-box__content {
    padding: 30px 0px;
    font-weight: 500;
    padding-right: 40px;
    font-size: 16px;
    color: #121212;
    text-align: center;
    line-height: 20px;
    padding: 30px 40px;
  }

  .el-icon-close {

    font-weight: 700;
    color: #121212 !important;
  }

  .el-message-box__btns {
    margin-bottom: 25px;
    padding: 0 40px;
    background: #ffffff;
    border-radius: 20px;

    justify-content: center;
    display: flex;
    flex-direction: row-reverse;


    /* 反转子元素顺序 */
    // 翻转
    .el-button {
      padding: 0 10px;

      &:last-child {
        min-width: 120px;
        height: 40px;
        background: #d12a1d;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        padding: 0 15px;
        border-radius: 10px;
        margin-left: 0px;
        margin-right: 20px;
      }

      &:first-child {
        min-width: 120px;
        height: 40px;
        background: #ffffff;
        padding: 0 15px;
        border-radius: 10px;
        font-weight: 400;
        font-size: 14px;
        color: #222222;
        border: 1px solid #dfdfdf;
      }
    }
  }
}

/deep/.el-dialog__wrapper {
  .el-dialog {
    border-radius: 6px !important;
  }
}

html,
body,
#app {
  height: 100%;
  font-family: 'Roboto-Regular, Roboto';
}

/deep/ .el-input__inner {
  font-family: 'Roboto-Regular, Roboto';
  color: pink !important;
}

* {
  box-sizing: border-box;
}

a {
  cursor: pointer;
}

.poinDone {
  pointer-events: none;

  &*,
  *,
  *::before {
    pointer-events: none;
  }
}

input[type='checkbox'] {
  $checkBoxSize: 20px;

  width: $checkBoxSize;
  height: $checkBoxSize;
  border-radius: 50%;
  border: 1px solid #888888;
  background-color: white;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  &:checked {
    background: #ff730b;
    border: none;
  }

  &:checked::after {
    content: '';

    background: transparent;
    border: #fff solid 1.5px;
    border-top: none;
    border-right: none;
    height: 2px;
    width: 40%;
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg) translate(1px, -1px);
  }
}

button {
  cursor: pointer;
  transition: 0.3s;
  background-color: transparent;
}

.anniu {
  border: solid;
  position: fixed;
  width: 100px;
  height: 100px;
  left: 0px;
  z-index: 55999999;
}

// 禁用状态下的组件字体颜色
.is-disabled .el-input__inner {
  color: #666666;
}
</style>
<style>
#cnzz_stat_icon_1281134212 {
  opacity: 0;
  height: 0;
}
</style>
